import { render, staticRenderFns } from "./HomeAppItemBrand.vue?vue&type=template&id=99cb21fe&scoped=true&"
import script from "./HomeAppItemBrand.vue?vue&type=script&lang=ts&"
export * from "./HomeAppItemBrand.vue?vue&type=script&lang=ts&"
import style0 from "./HomeAppItemBrand.vue?vue&type=style&index=0&id=99cb21fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99cb21fe",
  null
  
)

export default component.exports